import React from "react";

import RichText from "@/components/atoms/rich-text/rich-text";
import { TextButton } from "@/components/molecules/cta-button/cta-buttons";
import { useAppSelector } from "@/store/hook";

import MatchingTravelersListWithMedicalConditions from "./matching-travelers-list";

type MTAConsentYesModalProps = {
  modalContentOne: string;
  modalCancelBtnText: string;
  modalConfirmBtnText: string;
  modalContentTwo: string;
  modalMiddleContentTitle: string;
  modalMiddleContentDescription: string;
  modalConfirmBtnClick: (action: boolean) => void;
};

function MTAConsentYesModal(props: MTAConsentYesModalProps) {
  const {
    modalContentOne,
    modalCancelBtnText,
    modalConfirmBtnText,
    modalContentTwo,
    modalMiddleContentTitle,
    modalMiddleContentDescription,
    modalConfirmBtnClick,
  } = props;
  const { attributes } = useAppSelector((state) => state.quote);
  const { paymentDetails } = attributes;

  const isMTAPriceGreaterThanZero =
    Number(paymentDetails?.paymentOptions[0].cardPayment.card.mtaPrice) > 0;

  const MTAPrice = isMTAPriceGreaterThanZero
    ? paymentDetails?.paymentOptions[0].cardPayment.card.mtaPrice
    : 0;

  return (
    <>
      <RichText
        richText={modalContentOne}
        className="text-start mb-spacing-s text-xs leading-[27px] font-normal text-text-body"
        id="modal-content-one"
      />

      <div>
        <MatchingTravelersListWithMedicalConditions />
      </div>
      <div className="mt-[6px]">
        <span className="font-bold text-xs font-body-font leading-[27px] text-text-info-1-primary break-words">
          {modalMiddleContentTitle}
        </span>
        <div className="flex justify-between mt-[14px]">
          <span className="font-normal text-xs font-body-font leading-[27px] text-text-info-1-primary break-words">
            {modalMiddleContentDescription}
          </span>
          <span className="font-bold text-xs font-body-font leading-[27px] text-text-info-1-primary break-words">
            £{MTAPrice}
          </span>
        </div>
      </div>
      {isMTAPriceGreaterThanZero && (
        <RichText
          richText={modalContentTwo}
          className="text-start mb-spacing-l text-xs leading-[27px] font-normal md:mt-spacing-xl mt-[28px] text-text-body"
          id="modal-content-two"
        />
      )}
      <div
        className={`flex flex-col justify-center items-center gap-spacing-l ${
          !isMTAPriceGreaterThanZero ? "mt-spacing-xl" : ""
        }`}
      >
        <TextButton
          id="modal-confirm-button"
          hierarchy="primary"
          data-testid="confirm-button"
          label={modalConfirmBtnText as string}
          onClick={() => {
            if (modalConfirmBtnClick) {
              modalConfirmBtnClick(true);
            }
          }}
          className={` md:mr-2 md:mb-0 mb-2 !h-[48px]  leading-[18px] w-full !text-text-functional-1`}
        />
        <TextButton
          id="modal-cancel-button"
          hierarchy="tertiary"
          data-testid="cancel-button"
          label={modalCancelBtnText as string}
          onClick={() => {
            if (modalConfirmBtnClick) {
              modalConfirmBtnClick(false);
            }
          }}
          isLeftIcon={false}
          className=" text-xs leading-[18px] font-semibold"
        />
      </div>
    </>
  );
}

export default MTAConsentYesModal;
